var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"justify-center":"","fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"md12":""}}),_c('v-img',{attrs:{"max-width":"550","src":require('../assets/logo.png')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }